import moment from 'moment';

// Get the beginning of day (e.g. midnight)
export default (date: moment.MomentInput) => moment(date).startOf('day').local().toDate();
